import { render, staticRenderFns } from "./FiltroPendentes.vue?vue&type=template&id=5d0117a6&"
import script from "./FiltroPendentes.vue?vue&type=script&lang=js&"
export * from "./FiltroPendentes.vue?vue&type=script&lang=js&"
import style0 from "./FiltroPendentes.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports